window.ENV = {
  ACM_BASE_URL: import.meta.env.VITE_ACM_BASE_URL,
  ACM_BACKEND_URL: import.meta.env.VITE_ENDPOINT_CORE_BACKEND,
  RECOMMENDATION_URL: import.meta.env.VITE_ENDPOINT_RECOMMENDATION,
};
